import React from 'react';
import { DogIcon, BeakerIcon, ArrowRightIcon } from 'lucide-react';
export function ExpertAdvice() {
  const articles = [{
    title: 'Choosing the Right Dog Food for Your Breed',
    category: 'Pet Care',
    readTime: '5 min read',
    image: 'https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=600&q=80',
    badgeColor: 'badge-blue'
  }, {
    title: 'Getting Your Garden Summer-Ready',
    category: 'Garden Tips',
    readTime: '4 min read',
    image: 'https://images.unsplash.com/photo-1591857177580-dc82b9ac4e1e?w=600&q=80',
    badgeColor: 'badge-green'
  }, {
    title: 'Pool Maintenance Made Simple',
    category: 'Pool Care',
    readTime: '6 min read',
    image: 'https://cdn.magicpatterns.com/uploads/gJieNaGpPTNuQ4dJHRdHbU/Better_pets_pool_maintenance.jpg',
    badgeColor: 'badge-blue'
  }, {
    title: 'Setting Up Your First Aquarium',
    category: 'Fish and Aquatics',
    readTime: '7 min read',
    image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=600&q=80',
    badgeColor: 'badge-blue'
  }];
  return <section className="section-padding bg-warm-50" data-id="element-63">
      <div className="container-wide" data-id="element-64">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4" data-id="element-65">
          <div className="max-w-2xl" data-id="element-66">
            <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-gray-900 mb-4" data-id="element-67">
              Expert Advice, Tools and Guides
            </h2>
            <p className="text-lg text-gray-600" data-id="element-68">
              Helpful tools and guides from our team of local experts.
            </p>
          </div>
          <button className="text-brand-blue font-heading font-bold hover:text-brand-blue-700 transition-colors flex items-center gap-2 group active:scale-95" data-id="element-69">
            Browse All Advice
            <ArrowRightIcon className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" data-id="element-70" />
          </button>
        </div>

        {/* Interactive Tools */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-71">
          <div className="bg-brand-blue-50 rounded-2xl p-6 shadow-sm hover:shadow-md transition-all duration-300 group cursor-pointer border border-brand-blue-100 flex items-start gap-5 active:scale-[0.98]" data-id="element-72">
            <div className="w-12 h-12 rounded-xl bg-brand-blue text-white flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-73">
              <DogIcon className="w-6 h-6" data-id="element-74" />
            </div>
            <div data-id="element-75">
              <h3 className="font-heading font-extrabold text-xl text-gray-900 mb-2" data-id="element-76">
                Pet Food Finder
              </h3>
              <p className="text-gray-600 text-sm mb-3" data-id="element-77">
                Answer 3 quick questions for personalised food recommendations.
              </p>
              <span className="font-heading font-bold text-brand-blue flex items-center gap-1 group-hover:text-brand-blue-700 transition-colors text-sm" data-id="element-78">
                Try It Free{' '}
                <ArrowRightIcon className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" data-id="element-79" />
              </span>
            </div>
          </div>

          <div className="bg-cyan-50 rounded-2xl p-6 shadow-sm hover:shadow-md transition-all duration-300 group cursor-pointer border border-cyan-100 flex items-start gap-5 active:scale-[0.98]" data-id="element-80">
            <div className="w-12 h-12 rounded-xl bg-cyan-600 text-white flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-81">
              <BeakerIcon className="w-6 h-6" data-id="element-82" />
            </div>
            <div data-id="element-83">
              <h3 className="font-heading font-extrabold text-xl text-gray-900 mb-2" data-id="element-84">
                Pool Chemical Calculator
              </h3>
              <p className="text-gray-600 text-sm mb-3" data-id="element-85">
                Enter your pool size for exact chemical dosing and maintenance.
              </p>
              <span className="font-heading font-bold text-cyan-700 flex items-center gap-1 group-hover:text-cyan-800 transition-colors text-sm" data-id="element-86">
                Try It Free{' '}
                <ArrowRightIcon className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" data-id="element-87" />
              </span>
            </div>
          </div>
        </div>

        {/* Expert Articles Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-88">
          {articles.map((article, index) => <div key={index} className="card-interactive flex flex-col overflow-hidden cursor-pointer group border border-gray-100 active:scale-[0.98]" data-id="element-89">
              <div className="h-48 relative overflow-hidden" data-id="element-90">
                <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105" style={{
              backgroundImage: `url(${article.image})`
            }} data-id="element-91"></div>
              </div>
              <div className="p-6 flex flex-col flex-grow bg-white" data-id="element-92">
                <div className="flex justify-between items-center mb-3" data-id="element-93">
                  <span className={`${article.badgeColor} bg-white shadow-sm`} data-id="element-94">
                    {article.category}
                  </span>
                  <span className="text-xs text-gray-500 font-medium" data-id="element-95">
                    {article.readTime}
                  </span>
                </div>
                <h3 className="font-heading font-bold text-lg text-gray-900 mb-4 line-clamp-2 flex-grow group-hover:text-brand-blue transition-colors" data-id="element-96">
                  {article.title}
                </h3>
                <div className="text-sm font-bold text-brand-blue flex items-center gap-1 mt-auto" data-id="element-97">
                  Read More{' '}
                  <span className="transform group-hover:translate-x-1 transition-transform" data-id="element-98">
                    →
                  </span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}